<template lang="pug">
div
	v-data-iterator.mb-6(:items="items" :items-per-page="30" hide-default-footer disable-pagination)
		template(#item="{item}")
			user-content(v-bind="item" :date="item.created_at" type="review" :adminPath="item.meta.adminPath" :key="item.id")
				template(#chips)
					review-chips(:review="item")
</template>
<script>
import UserContent from '@/components/user-content/item.vue';
import ReviewChips from '@/components/user-content/review-chips';

export default {
	components: {
		UserContent,
		ReviewChips
	},
	props: {
		items: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {};
	}
};
</script>
